var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0414 20.1557L27.7517 25.866L25.8661 27.7516L20.1558 22.0413C18.1026 23.684 15.4987 24.6667 12.6667 24.6667C6.04275 24.6667 0.666748 19.2907 0.666748 12.6667C0.666748 6.04267 6.04275 0.666672 12.6667 0.666672C19.2907 0.666672 24.6667 6.04267 24.6667 12.6667C24.6667 15.4987 23.6841 18.1025 22.0414 20.1557ZM19.3663 19.1664C20.9967 17.4861 22.0001 15.1941 22.0001 12.6667C22.0001 7.51 17.8234 3.33334 12.6667 3.33334C7.51008 3.33334 3.33341 7.51 3.33341 12.6667C3.33341 17.8233 7.51008 22 12.6667 22C15.1942 22 17.4862 20.9967 19.1665 19.3663L19.3663 19.1664Z",
    fill: "#ffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ec3d2c9de9cac4e9e95c851d7eda7669.svg";
export { ForwardRef as ReactComponent };